import { Button, message, Modal, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import AppInput from "../../../../components/AppInput";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import SelectInput from "../../../../components/SelectInput";
import useUserData from "../../../../hooks/useUserData";
import useDocumentUpload from "../../../../hooks/useDocumentUpload";
import SecurityCodeModal from "../../../../components/SecurityCodeModal";
import TextArea from "antd/es/input/TextArea";

function EditCargoRecordBookModel({ visible, onClose, child_id, cargo_id }) {
  const navigate = useNavigate();
  const user = useUserData();
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});
  const [code, set_code] = useState("");
  const [date, set_date] = useState(null);
  const [signature, set_signature] = useState("");
  const [codeList, setCodeList] = useState([]);
  const [codeItemList, setCodeItemList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [submitStatus, setSubmitStatus] = useState(false);
  const [initialDocument, setInitialDocument] = useState([]);
  const [soft_delete, set_soft_delete] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [previous_log_date, set_Previous_Log_Date] = useState("");
  const { documentList, handleDocumentChange, getFilesForUpload } =
    useDocumentUpload(initialDocument);
  let codes = "K";

  const viewOnly = localStorage.getItem("viewOnly");

  const LIST_CARGO_RECORD_CODE_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_cargo_codes_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setCodeList(res?.cargo_codes);
        }
      });
    } catch (error) {
      console.error("Error fetching Code list:", error);
    }
  };

  const LIST_CARGO_RECORD_ITEM_API = (code_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("code", code_id);
      post(ApiURL.get_cargo_item_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const newRes = res?.items?.map((item) => ({
            value: item?.id,
            label: item?.description,
            sub_code_name: item?.subdetails_child,
          }));
          setCodeItemList(newRes);
        }
      });
    } catch (error) {
      console.error("Error fetching Code Item list:", error);
    }
  };

  const handleCheckboxChange = (value) => {
    setSelectedItems((prevItems) => {
      const exists = prevItems.find((item) => item.id === value);
      return exists
        ? prevItems.filter((item) => item.id !== value)
        : [...prevItems, { id: value, value: "" }];
    });
  };

  const handleInputChange = (id, inputValue) => {
    setSelectedItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, value: inputValue } : item
      )
    );
  };

  const VIEW_CARGO_RECORD_BOOK_APIS = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("record_id", child_id);
    FORM_DATA.append("parent_id", atob(cargo_id));
    FORM_DATA.append("request_type", "view");
    post(ApiURL.view_or_update_cargo_details_st, FORM_DATA).then((res) => {
      if (res?.status == true) {
        const cargoRecordData = res?.data;
        const subDetailValues = Array.isArray(
          cargoRecordData?.sub_detail_values
        )
          ? cargoRecordData?.sub_detail_values
          : typeof cargoRecordData?.sub_detail_values === "string"
          ? JSON.parse(cargoRecordData?.sub_detail_values || "[]")
          : [];

        setSelectedItems(subDetailValues);
        set_code(cargoRecordData?.operationCode);
        set_date(cargoRecordData?.date);
        set_signature(cargoRecordData?.cargo_sign);
        setSubmitStatus(res?.submit_status);
        setInitialDocument(cargoRecordData?.files);
        set_soft_delete(cargoRecordData?.soft_delete);
        set_Previous_Log_Date(res?.last_date);
      } else {
        set_errors(res?.errors || {});
      }
    });
  };

  const UPDATE_CARGO_RECORD_BOOK_APIS = async (save_submit) => {
    const files = getFilesForUpload();
    set_loader(true);
    if (selectedItems.some((item) => !item.value)) {
      alert("All checked input should be filled");
      set_loader(false);
      return;
    }
    const FORM_DATA = new FormData();
    FORM_DATA.append("request_type", "edit");
    FORM_DATA.append("save_submit", Number(save_submit) || 0);
    FORM_DATA.append("record_id", atob(cargo_id));
    FORM_DATA.append("code_category_id", code);
    FORM_DATA.append("sub_detail_values", JSON.stringify(selectedItems));
    FORM_DATA.append("date", date);
    FORM_DATA.append("cargo_sign", signature);
    files?.forEach((file) => {
      FORM_DATA.append("files", file);
    });
    post(ApiURL.view_or_update_cargo_details_st, FORM_DATA).then((res) => {
      set_loader(false);
      if (res?.status == true) {
        SuccessToast(
          "Congratulation!!",
          "Update Cargo Record Details Successfully Updated!!"
        );
        navigate("/list-cargo-record");
      } else {
        ErrorToast("Error message", res?.message);
        set_errors(res?.errors || {});
      }
    });
  };

  useEffect(() => {
    LIST_CARGO_RECORD_CODE_API();
    if (child_id) VIEW_CARGO_RECORD_BOOK_APIS();
  }, [child_id, visible]);

  useEffect(() => {
    if (code) {
      LIST_CARGO_RECORD_ITEM_API(code);
    }
  }, [code]);

  const getDocUrl = (file) => {
    if (file.url) return file.url;
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
    return null;
  };

  const handlePreviews = (file) => {
    const url = getDocUrl(file);
    if (!url) {
      message.error("No preview available for this file");
      return;
    }
    window.open(url, "_blank");
  };

  const reomveItem = async (file) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("file_name", file.name);
      const res = await post(ApiURL.remove_ballast_file_st, FORM_DATA);
      if (res?.status === true) {
        SuccessToast("Success", "File removed successfully");
        VIEW_CARGO_RECORD_BOOK_APIS();
      } else {
        ErrorToast("Error", "Failed to remove file");
      }
    } catch (error) {
      console.error("Error removing file:", error);
      ErrorToast("Error", "Failed to remove file");
    }
  };

  const groupedOptions = codeItemList.flatMap((item) => {
    const subCodes = Array.isArray(item.sub_code_name)
      ? item.sub_code_name
      : [];

    if (subCodes.length > 0) {
      return {
        label: <p style={{ fontSize: "15px" }}>{item.label}</p>,
        options: subCodes.map((sub, index) => ({
          value: `${item.value}-${index}`,
          label: sub?.subdetails_child || "",
        })),
      };
    } else {
      return {
        value: item.value,
        label: item.label || "",
      };
    }
  });

  return (
    <>
      <Modal
        open={visible}
        onCancel={onClose}
        footer={[
          <Button key="cancel" onClick={onClose}>
            Cancel
          </Button>,
          ((!soft_delete &&
            user?.data?.designation !== "Captain" &&
            child_id) ||
            viewOnly == 1) &&
            viewOnly != 0 && (
              <Button
                key="captain-save"
                type="primary"
                loading={loader}
                onClick={UPDATE_CARGO_RECORD_BOOK_APIS}
              >
                Save
              </Button>
            ),
        ]}
        width={1000}
      >
        <div className="white-container">
          <br />
          <h3>Cargo Record Information</h3>
          <br />

          <div className="row">
            <div className="col-6">
              <SelectInput
                disabled={submitStatus}
                label="Code"
                value={code}
                placeholder="-- Select Code --"
                style={{ width: "100%" }}
                onChange={(value) => {
                  set_code(value);
                  setSelectedItems([]);
                  LIST_CARGO_RECORD_ITEM_API(value);
                }}
                options={codeList}
                errors={errors?.code}
              />
            </div>
            <div className="col-6">
              <AppInput
                disabled={submitStatus}
                type="date"
                label="Date"
                placeholder="Date"
                value={date}
                onChange={(e) => set_date(e.target.value)}
                errors={errors.date}
                // min={previous_log_date}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>

          {code && (
            <div
              className="col-12"
              style={{
                lineHeight: "2",
                border: "1px solid #d9d9d9",
                borderRadius: "5px",
              }}
            >
              <strong className="form-label">Select Items:</strong>
              {groupedOptions.map((optionGroup, index) => (
                <div key={index} className="mb-3">
                  {/* Main Label as Checkbox */}
                  <div className="row align-items-center mb-2">
                    <div className="col-6">
                      <div className="form-check">
                        {optionGroup?.options?.length > 1 ? (
                          ""
                        ) : (
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value={optionGroup.label}
                            checked={selectedItems.some(
                              (item) => item.id === optionGroup.value
                            )}
                            onChange={() =>
                              handleCheckboxChange(optionGroup.value)
                            }
                            id={`group-checkbox-${index}`}
                          />
                        )}
                        <label
                          className="form-check-label"
                          htmlFor={`group-checkbox-${index}`}
                          style={{ textTransform: "none" }}
                        >
                          {typeof optionGroup.label === "string" ? (
                            <strong>{optionGroup.label}</strong>
                          ) : (
                            <strong>{optionGroup.label.props.children}</strong>
                          )}
                        </label>
                      </div>
                    </div>

                    {/* Input Field for Main Label */}
                    <div className="col-6" style={{ marginLeft: "22px" }}>
                      {selectedItems.some(
                        (item) => item.id === optionGroup.value
                      ) && (
                        <TextArea
                          required
                          maxLength={1000}
                          className="form-control"
                          autoSize={{ minRows: 1 }}
                          placeholder={
                            typeof optionGroup.label === "string"
                              ? optionGroup.label
                              : optionGroup.label.props.children
                          }
                          value={
                            selectedItems.find(
                              (item) => item.id === optionGroup.value
                            )?.value || ""
                          }
                          onChange={(e) =>
                            handleInputChange(optionGroup.value, e.target.value)
                          }
                        />
                      )}
                    </div>
                  </div>

                  {/* Sub-options */}
                  {optionGroup.options && (
                    <div
                      className="ms-3"
                      style={{ marginLeft: "30px", padding: "10px" }}
                    >
                      {optionGroup.options.map((option) => (
                        <div
                          key={option.value}
                          className="row align-items-center mb-2"
                        >
                          {/* Left Side - Checkbox */}
                          <div className="col-6">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value={option.value}
                                checked={selectedItems.some(
                                  (item) => item.id === option.value
                                )}
                                onChange={() =>
                                  handleCheckboxChange(option.value)
                                }
                                id={`checkbox-${option.value}`}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`checkbox-${option.value}`}
                              >
                                {option.label}
                              </label>
                            </div>
                          </div>

                          {/* Right Side - Input Field */}
                          <div className="col-6" style={{ padding: "5px" }}>
                            {selectedItems.some(
                              (item) => item.id === option.value
                            ) && (
                              <TextArea
                                required
                                maxLength={1000}
                                className="form-control"
                                autoSize={{ minRows: 1 }}
                                placeholder={option.label}
                                value={
                                  selectedItems.find(
                                    (item) => item.id === option.value
                                  )?.value || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    option.value,
                                    e.target.value
                                  )
                                }
                              />
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          {errors?.sub_detail_values && (
            <span style={{ color: "red" }}>{errors?.sub_detail_values}</span>
          )}

          <div className="row" style={{ paddingTop: "10px" }}>
            <div className="col-6">
              <AppInput
                disabled={submitStatus}
                label="Sign/ Name of officer incharge / Rank/ Date of entry dd-mmm-yyyy"
                placeholder="Sign/ Name of officer incharge / Rank/ Date of entry dd-mmm-yyyy"
                value={signature}
                onChange={(e) => set_signature(e.target.value)}
                errors={errors.signature}
                showInfo={code !== "K"}
                infoMessage="Signatur of In-charge (or  C/O if signed off)"
              />
            </div>
            <div className="col-6">
              <div
                className="input-box"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  alignItems: "flex-start",
                }}
              >
                <label>Select File</label>
                <Upload
                  accept=".pdf,.doc,.docx,.xls,.xlsx"
                  multiple
                  fileList={documentList}
                  onChange={handleDocumentChange}
                  onPreview={handlePreviews}
                  beforeUpload={() => false}
                  listType="picture"
                  onRemove={reomveItem}
                >
                  <Button
                    icon={<UploadOutlined />}
                    type="primary"
                    style={{
                      borderRadius: "50%",
                      padding: "10px",
                      width: "40px",
                      height: "40px",
                      marginLeft: "10px",
                    }}
                  />
                </Upload>
              </div>
            </div>
          </div>

          <SecurityCodeModal
            record_id={cargo_id}
            visible={modalVisible}
            setModalVisible={setModalVisible}
            onCancel={() => setModalVisible(false)}
            onSuccess={() => {
              UPDATE_CARGO_RECORD_BOOK_APIS("1");
              setModalVisible(false);
            }}
            apiEndPoint={ApiURL.verify_security_code_st}
          />
        </div>
      </Modal>
    </>
  );
}

export default EditCargoRecordBookModel;
